import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import PublicBooking from "@/pages/PublicBooking";
import PortalLayout from "@/pages/portal/PortalLayout";
import CalendarPage from "@/pages/portal/CalendarPage";
import ReportsPage from "@/pages/portal/ReportsPage";
import JobsPage from "@/pages/portal/JobsPage";
import GalleryPage from "@/pages/portal/GalleryPage";
import ReviewsPage from "@/pages/portal/ReviewsPage";

const RequireAuth = ({ children }) => {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/booking/:id" element={<PublicBooking />} />
              <Route
                path="/portal"
                element={
                  <RequireAuth>
                    <PortalLayout />
                  </RequireAuth>
                }
              >
                <Route index element={<Navigate to="calendar" replace />} />
                <Route path="calendar" element={<CalendarPage />} />
                <Route path="jobs" element={<JobsPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="reviews" element={<ReviewsPage />} />
                <Route path="gallery" element={<GalleryPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
